import React, { Suspense } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingCard from "./components/LoadingCard";
import PageLayout from "./components/PageLayout";

export default function LazyRoute({ children }) {
  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <PageLayout>
            <LoadingCard />
          </PageLayout>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  );
}
